<template>
  <div v-if="game.state.screen === 'playing'" class="move-counter">
    Moves: {{ game.state.gameplay.currentMoveCount }}<span v-if="game.state.gameplay.currentUndoCount > 0"> ({{ game.state.gameplay.currentUndoCount }} {{ game.state.gameplay.currentUndoCount === 1 ? 'Undo' : 'Undos' }})</span>
  </div>
</template>

<script setup>
import { inject } from 'vue';

const game = inject('game');
</script>

<style scoped>
.move-counter {
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: var(--hw-text);
  font-size: 18px;
  text-shadow: 1px 1px 2px black;
  background-color: var(--hw-bg-overlay);
  border: 1px solid var(--hw-border);
  padding: 8px 12px;
  border-radius: var(--hw-radius);
  z-index: 1000;
  pointer-events: none;
}
</style>
